import { useTranslation } from "react-i18next";
import { useAuthStore } from "../stores/authStore";

/**
 * Full-screen recoverable error when auth tokens exist but the backend cannot be reached.
 */
export default function BackendUnavailableScreen() {
  const { t } = useTranslation();
  const retryAuth = useAuthStore((state) => state.retryAuth);
  const logout = useAuthStore((state) => state.logout);
  const isLoading = useAuthStore((state) => state.isLoading);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-xl font-semibold text-gray-900">
        {t("auth.backendUnavailableTitle")}
      </h1>
      <p className="max-w-md text-sm text-gray-600">
        {t("auth.backendUnavailableMessage")}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-60"
          disabled={isLoading}
          onClick={() => {
            void retryAuth();
          }}
        >
          {t("auth.backendUnavailableRetry")}
        </button>
        <button
          type="button"
          className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60"
          disabled={isLoading}
          onClick={() => {
            logout();
          }}
        >
          {t("auth.logout")}
        </button>
      </div>
    </div>
  );
}
